// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".filter-item .filter-item-img[data-v-e5a331e0]{width:40px;height:40px}.filter-item .filter-item-img--disabled[data-v-e5a331e0]{opacity:.5}", ""]);
// Exports
module.exports = exports;
